import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NgTemplateOutlet } from "@angular/common";

@Component({
  selector: "app-base-dialog",
  standalone: true,
  imports: [NgTemplateOutlet],
  template: `
    @if (data["template"]) {
      <ng-container [ngTemplateOutlet]="data['template']"></ng-container>
    }
  `,
})
export class BaseModalComponent<C, D> {
  dialogId?: string;
  disableClose?: boolean;

  protected readonly dialogRef: MatDialogRef<C> = inject(MatDialogRef<C>);
  protected data: D = inject(MAT_DIALOG_DATA);

  constructor() {
    this.dialogId = this.dialogRef.id;
    this.disableClose = this.dialogRef?.disableClose;
  }

  close(result = null): void {
    this.dialogRef.close(result);
  }

  updateModalSize(width: number, height: number): void {
    this.dialogRef.updateSize(width + "px", height + "px");
  }
}
